import { useState } from "react";
import man from "../assets/images/group/man.png"

type Props = {
  image: string;
  itemName: string;
  itemPrice: number;
  discountedPrice: number;
  quantity: string;
  addedBy: string;
  onCountChange?: (count: number) => void;
};

const GroupOrderedItem = ({
  image,
  itemName,
  itemPrice,
  discountedPrice,
  quantity,
  addedBy,
  onCountChange,
}: Props) => {
 

  return (
    <div className="py-[20px] border-b-2 border-dashed">
      <div className="flex justify-between items-center">
        <div className="flex gap-[20px] items-center">
          <div className="flex items-center gap-4">
            <img
              src={image}
              alt="Food Item"
              className="h-[75px] w-[75px] rounded-[12px]"
            />
          </div>
          <div>
            <p className="text-[#050505] font-Urbanist text-[25px] font-medium leading-[25px]">
              {itemName}
            </p>
            <p className="text-[#FF8A00] font-Urbanist text-[18px] font-medium leading-[22px]">
              {discountedPrice}{" "}
              <span className="line-through text-[#6A6A6A] ml-[15px]">
                {itemPrice}
              </span>
            </p>
            <p className="text-[#050505] font-Urbanist text-[15px] font-normal leading-[22px]">
              {quantity}
            </p>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3">
            <img src={man} alt="Added by" className="h-[20px] w-[20px]" />
            <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-medium leading-[20px]">
              Added by {addedBy}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupOrderedItem;
